import { useState, useEffect, useRef } from "react";

export function useAutoScan(runScan) {
  const [autoScan,      setAutoScan]      = useState(false);
  const [autoInterval,  setAutoInterval]  = useState(10);
  const [countdown,     setCountdown]     = useState(null);
  const autoRef = useRef(null);
  const cdRef   = useRef(null);

  /**
   * The scan callback is held in a ref rather than depended on directly.
   *
   * runScan is rebuilt whenever anything it closes over changes, and this
   * effect owns a one-second countdown whose every tick re-renders the parent.
   * Depending on the callback identity therefore meant restarting the schedule
   * faster than it could ever reach its deadline. The timer now depends only
   * on whether auto-scan is on and how long the interval is, and always calls
   * the latest callback through the ref.
   */
  const runScanRef = useRef(runScan);
  useEffect(() => { runScanRef.current = runScan; }, [runScan]);

  useEffect(() => {
    if (autoScan) {
      const ms = autoInterval * 60000;
      let rem = ms / 1000;
      setCountdown(Math.round(rem));
      cdRef.current  = setInterval(() => { rem -= 1; setCountdown(Math.round(rem)); if (rem <= 0) rem = ms / 1000; }, 1000);
      autoRef.current = setInterval(() => runScanRef.current(), ms);
    } else {
      clearInterval(autoRef.current);
      clearInterval(cdRef.current);
      setCountdown(null);
    }
    return () => { clearInterval(autoRef.current); clearInterval(cdRef.current); };
  }, [autoScan, autoInterval]);

  return { autoScan, setAutoScan, autoInterval, setAutoInterval, countdown };
}
